import { render } from "./relatorio-estoque.vue?vue&type=template&id=ff3a6632"
import script from "./relatorio-estoque.vue?vue&type=script&lang=js"
export * from "./relatorio-estoque.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__